function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#vistapage_add_svg__clip0_2818_3850)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 1.5A2.5 2.5 0 000 4v4.5h24V4a2.5 2.5 0 00-2.5-2.5h-19zM3 5a1.25 1.25 0 112.5 0A1.25 1.25 0 013 5zm4 0a1.25 1.25 0 112.5 0A1.25 1.25 0 017 5zm13 11a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1zm3 1.5c.356 0 .694.074 1 .208V10H0v9.5A2.5 2.5 0 002.5 22h12.4c.193 0 .29-.265.168-.413A2.5 2.5 0 0117 17.5a.5.5 0 00.5-.5 2.5 2.5 0 015 0 .5.5 0 00.5.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "vistapage_add_svg__clip0_2818_3850"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var SvgVistapageAdd = function SvgVistapageAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "#fff"
  }, props), _ref, _ref2);
};

export default SvgVistapageAdd;